import React, { useState } from 'react'
import { withStyles, Typography, Button } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useDispatch, useSelector } from 'react-redux'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import SelectionPopup from 'src/components/selection-popup'
import styles from './styles'
import clsx from 'clsx'
const AddCardDivider = props => {
  const { classes, section, sections, setSections } = props
  const dispatch = useDispatch()
  const [iconColor, setIconColor] = useState('')
  const open = useSelector(state => state.course.sectionDrawerOpen)
  const openCardSelection = () => {
    if (!open) {
      return
    }
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Select page type',
          maxWidth: 800,
          component: (
            <SelectionPopup
              section={section}
              sections={sections}
              setSections={setSections}
            />
          ),
        }),
      ),
    )
  }

  return (
    <div
      className={classes.divider}
      onMouseEnter={() => open && setIconColor('#5DADFF')}
      onMouseLeave={() => open && setIconColor('')}
      onClick={openCardSelection}
    >
      <div
        className={classes.dividerLine}
        style={{
          borderBottom:
            iconColor == '#5DADFF' ? '1px solid #5DADFF' : '1px solid #dee2e6',
        }}
      />
      <Button
        variant="contained"
        className={classes.button}
        style={{ backgroundColor: iconColor }}
      >
        <div className={classes.buttonContent}>
          <Icon icon="uil:plus" className={classes.icon} />
          <Typography className={classes.buttonText}>Add Page</Typography>
        </div>
      </Button>
      <div
        className={classes.dividerLine}
        style={{
          borderBottom:
            iconColor == '#5DADFF' ? '1px solid #5DADFF' : '1px solid #dee2e6',
        }}
      />
    </div>
  )
}

export default withStyles(styles)(AddCardDivider)
